export default __webpack_public_path__ + "static/media/FourthImage.38fbf38e.png";